// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qwHUd","colMin":"styles_colMin__3r_BW"};